function MenuItem({content, className, clickHandler}){
	return <li className={className} key={content} onClick={clickHandler} ><span className="go-content">{content}</span></li>
}

export default MenuItem